/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('bill');
const BILL_LIST = "BILL_LIST";
const BILL_ADD = "BILL_ADD";
const BILL_DELETE = "BILL_DELETE";
const BILL_EDIT = "BILL_EDIT";
const BILL_DETAIL = "BILL_DETAIL";
const BILL_ORDER = "BILL_ORDER";
const BILL_EXPRESS = "BILL_EXPRESS";
const BILL_EXPORT = "BILL_EXPORT";
const BILL_INFO = "BILL_INFO";
const BILL_INFOLIST = "BILL_INFOLIST";
const BILL_INFOADD = "BILL_INFOADD";
const BILL_INFOTRASH = "BILL_INFOTRASH";

export default {
    BILL_EXPORT,
    billExport:(params)=>{
        var obj = Object.assign({}, params);
        delete obj.balance_list;
        delete obj.current;
        delete obj.total;
        delete obj.total_balance;
        delete obj.dir;
        delete obj.pageSize;
        delete obj.page;
        return ajaxCommon({
            api:{
                url:'/api/bill/export',
                method:'get',
            },
            data:obj,
            success:(data)=>({
                type:BILL_EXPORT,
                data
            })
        })
    },
    BILL_EXPRESS,
    billExpress: (id)=>{
        return ajaxCommon({
            api:{
                url:'/api/bill/express?code=' + id,
                method:'get'
            },
            success:(data)=>({
                type:BILL_EXPRESS,
                data
            })
        })
    },
    BILL_ORDER,
    billForOrder: (id)=>{
        return ajaxCommon({
            api:{
                url:'/api/bill/order/' + id,
                method:'get'
            },
            success:(data)=>({
                type:BILL_ORDER,
                data
            })
        })
    },
    BILL_LIST,
    billList : (search)=>{
        search && (search.page = search.current || 1);//保持antd的风格
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:BILL_LIST,
                data
            })
        })
    },
    BILL_ADD,
    billAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:BILL_ADD,
                data
            })
        })
    },
    BILL_DELETE,
    billDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:BILL_DELETE,
                data,
            })
        })
    },
    BILL_EDIT,
    billEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:BILL_EDIT,
                data,
            })
        })
    },
    BILL_DETAIL,
    billDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:BILL_DETAIL,
                data,
            })
        })
    },
    BILL_INFO,
    billInfo:(id)=>{
        return ajaxCommon({
            api:TheApi('get')('infodetail'),
            data:{
                id
            },
            success:(data)=>({
                type:BILL_INFO,
                data
            })
        })
    },
    BILL_INFOLIST,
    billInfoList:(data)=>{
        return ajaxCommon({
            api:TheApi('get')('info'),
            data:data,
            success:(data)=>({
                type:BILL_INFOLIST,
                data,
            })
        })
    },
    BILL_INFOADD,
    billInfoAdd:(data)=>{
        return ajaxCommon({
            api:TheApi('post')('infocreate'),
            data:data,
            success:(data)=>({
                type:BILL_INFOADD,
                data
            })
        })
    },
    BILL_INFOTRASH,
    billInfoTrash:(id)=>{
        return ajaxCommon({
            api:TheApi('post')('infotrash'),
            data:{
                id
            },
            success:(data)=>({
                type:BILL_INFOTRASH,
                data
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/BillAction.js